import request from '@/utils/request'

export function getlearnrecord(query) {
	return request({
		url: 'api/learn/getlearnrecord',
		method: 'get',
		params: query
	})
}

export function getbooks(query) {
	return request({
		url: 'api/learn/getbooks',
		method: 'get',
		params: query
	})
}

export function savetest(query) {
	return request({
		url: 'api/learn/savetest',
		method: 'post',
		data: query
	})
}

export function gettestbytype(query) {
	return request({
		url: 'api/learn/gettestbytype',
		method: 'get',
		params: query
	})
}

export function gettesterrword(query) {
	return request({
		url: 'api/learn/gettesterrword',
		method: 'get',
		params: query
	})
}

export function dodel(query) {
	return request({
		url: 'api/learn/dodel',
		method: 'get',
		params: query
	})
}

export function gettestdetail(query) {
	return request({
		url: 'api/learn/gettestdetail',
		method: 'get',
		params: query
	})
}

export function exportword(query) {
	return request({
		url: 'api/learn/exportword',
		method: 'get',
		params: query
	})
}






